import { render, staticRenderFns } from "./alertreport.vue?vue&type=template&id=48e41bee&scoped=true&"
import script from "./alertreport.vue?vue&type=script&lang=js&"
export * from "./alertreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e41bee",
  null
  
)

export default component.exports